import AScene from '../../library/ExtendedObjects/AScene.js';
import gameData from '../../gameData.js';

export default class Boot extends AScene
{
    preload()
    {
        this.loadAtlas('preloader', 'assets/preloader');
        this.loadBitmapFont('preloader_font', 'assets/preloader');
    }

    loadAtlas(key, location)
    {
        this.load.multiatlas(key, location + '/' + key + '.json', location);
    }

    loadBitmapFont(key, location)
    {
        this.load.bitmapFont(key, location + '/' + key + '.png', location + '/' + key + '.fnt');
    }

    create()
    {
        this.scene.start('Preloader');
    }
}